import React from 'react'

type SkeletonVariant = 'kpi' | 'card' | 'table-row'

export default function Skeleton({ variant = 'card', count = 1 }: { variant?: SkeletonVariant; count?: number }) {
  const items = Array.from({ length: count }, (_, i) => i)

  if (variant === 'kpi') {
    return (
      <div className="kpi-grid">
        {items.map((i) => (
          <div key={i} className="kpi-card skeleton-card">
            <div className="skeleton-line skeleton-short" />
            <div className="skeleton-line skeleton-wide" />
          </div>
        ))}
      </div>
    )
  }

  if (variant === 'table-row') {
    return (
      <>
        {items.map((i) => (
          <div key={i} className="skeleton-row">
            <div className="skeleton-line skeleton-wide" />
            <div className="skeleton-line skeleton-short" />
          </div>
        ))}
      </>
    )
  }

  return (
    <>
      {items.map((i) => (
        <div key={i} className="card skeleton-card">
          <div className="skeleton-line skeleton-short" />
          <div className="skeleton-line skeleton-wide" />
          <div className="skeleton-line skeleton-mid" />
        </div>
      ))}
    </>
  )
}
